document.addEventListener('DOMContentLoaded',()=>{ 
  const header=document.querySelector('.site-header');
  document.addEventListener('click',e=>{const b=e.target.closest('[data-menu]');if(b&&header){header.classList.toggle('menu-open');}});
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!document.body.classList.contains('animations-enabled')||reduce){document.querySelectorAll('.reveal').forEach(el=>el.classList.add('is-visible'));return;}
  const style=document.documentElement;
  const animStyle=getComputedStyle(style).getPropertyValue('--animation-style').trim();
  document.querySelectorAll('.reveal').forEach((el,i)=>{
    el.style.setProperty('--reveal-delay',`calc(var(--animation-delay, .05s) * ${Math.min(i,10)})`);
    if(animStyle==='zoom') el.classList.add('anim-zoom');
    else if(animStyle==='fade') el.classList.add('anim-fade');
    else if(animStyle==='slide') el.classList.add('anim-slide');
  });
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.12,rootMargin:'0px 0px -40px'});
  document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));
  // Product gallery thumbnail swap
  document.querySelectorAll('.product-gallery').forEach(gallery=>{
    const main=gallery.querySelector('.main-product-img img');
    gallery.querySelectorAll('.thumbs img').forEach(thumb=>{
      thumb.style.cursor='pointer';
      thumb.addEventListener('click',()=>{if(main){main.src=thumb.src.replace(/width=\\d+/,'width=1200');main.alt=thumb.alt;}});
    });
  });
});